import usePermissions from "app/hooks/usePermissions";

const CanAccess = ({ permission, children }) => {
  const { hasPermission } = usePermissions();

  if (!hasPermission(permission)) {
    return null;
  }

  return children;
};

export default CanAccess;
